import { render, staticRenderFns } from "./TopCarriers.vue?vue&type=template&id=2bc1ef92&"
import script from "./TopCarriers.vue?vue&type=script&lang=js&"
export * from "./TopCarriers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports